<template>
  <section class="ut-p-6 prospect-stage-question">
    <h3 class="question-title">Have you contacted {{ prospect.contact.firstName }}?</h3>
    <div>
      <radio-button v-for="btn in answers"
                :key="btn.id"
                :id="btn.id"
                :name="'Have you contacted'"
                v-model="selectedAnswer"
                :selectedValue="selectedAnswer"
                :radioValue="btn.value">
                {{ btn.label }}</radio-button>
      <span class="error ut-text-sm ut-font-bold"
            v-show="validationError">
            Please select an option</span>
    </div>
    <button @click="confirm()"
            class="btn btn-green-inverted confirm-btn"
            :class="{ 'disabled': disabledButtonClick }">
            Confirm</button>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import RadioButton from '@/components/Forms/RadioButton.vue';
import ProspectStageType from '@/Mapper/ProspectStageType';

export default {
  name: 'ProspectStageQuesHaveYouContacted',
  components: {
    RadioButton,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      selectedAnswer: null,
      validationError: false,
      answers: [
        {
          id: 'have-you-contacted-yes',
          value: 'yes',
          label: 'Yes',
        },
        {
          id: 'have-you-contacted-no',
          value: 'no',
          label: 'I tried, no answer',
        },
      ],
      disabledButtonClick: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    ...mapActions('prospectStore', [
      'createStage',
    ]),
    confirm() {
      if (!this.selectedAnswer) {
        this.validationError = true;
        return false;
      }

      this.disabledButtonClick = true;

      if (this.selectedAnswer === 'yes') {
        // create contacted stage
        const payload = {
          prospectKey: this.prospect.key,
          stageTypeId: ProspectStageType.contacted,
          creatorUserId: this.userid,
        };

        this.$emit('update-view', 'rateProspectQuality');

        this.createStage(payload).then(() => {
          this.$emit('update-view', 'rateProspectQuality');
        }).catch((error) => {
          this.disabledButtonClick = false;
          console.log(error);
        });
      } else if (this.selectedAnswer === 'no') {
        // Follow Up Reminder
        this.$emit('update-view', 'followUpReminder');
      }

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
